interface PdfLink {
  lang : string;
  prod : string;
}

export class cProductInfo {

  div_pdf    = document.querySelector('.c-single-product-pdf')        as HTMLElement;
  script_pdf = document.querySelector('.c-single-product-pdf script') as HTMLScriptElement
  a_pdf      = document.createElement('a');

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const pdfLink = JSON.parse(this.script_pdf.textContent);

    this.div_pdf.append(this.a_pdf);

    const url = new URL('/c-product-pdf', window.location.origin);
    url.searchParams.append('lang' , pdfLink.lang);
    url.searchParams.append('product', pdfLink.prod);

    this.a_pdf.href        = url.toString();
    this.a_pdf.target      = '_blank';
    this.a_pdf.rel         = 'nofollow';
    this.a_pdf.textContent = __('PDF Herunterladen', 'custom');

    const fieldsets = document.querySelectorAll('.c-product-info-info-fields')     as unknown as HTMLElement[];

    for(const fieldset of fieldsets) {
      const button   = fieldset.querySelector('button') as HTMLButtonElement;
      button.addEventListener('click', () => fieldset.classList.toggle('c-open'));
      const h2   = fieldset.querySelector('h2') as HTMLElement;
      h2.addEventListener('click', () => fieldset.classList.toggle('c-open'));
    }
  }
}
